(function () {
  var directoryRecords = [];

  var icons = {
    chevron: '<svg viewBox="0 0 24 24" focusable="false"><path d="m9 18 6-6-6-6"/></svg>',
    website: '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3.6 9h16.8M3.6 15h16.8M12 3c2.1 2.2 3.2 5.2 3.2 9S14.1 18.8 12 21c-2.1-2.2-3.2-5.2-3.2-9S9.9 5.2 12 3Z"/></svg>',
    instagram: '<svg viewBox="0 0 24 24" focusable="false"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm5 14.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm5.25-9.75h.01"/></svg>',
    email: '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 5h16v14H4V5Zm0 2 8 6 8-6"/></svg>',
    phone: '<svg viewBox="0 0 24 24" focusable="false"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2Z"/></svg>'
  };

  function normalizeListField(value) {
    if (Array.isArray(value)) return value.filter(Boolean).map(function (item) {
      return String(item).trim();
    }).filter(Boolean);

    if (!value) return [];

    return String(value).split(',').map(function (item) {
      return item.trim();
    }).filter(Boolean);
  }

  function normalizeStringField(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeDirectoryRecord(record) {
    return {
      id: normalizeStringField(record.id),
      name: normalizeStringField(record.name),
      record_type: normalizeStringField(record.record_type),
      booth: normalizeStringField(record.booth),
      categories: normalizeListField(record.categories),
      represented_by: normalizeStringField(record.represented_by),
      brands_represented: normalizeListField(record.brands_represented),
      website: normalizeStringField(record.website),
      instagram: normalizeStringField(record.instagram),
      email: normalizeStringField(record.email),
      phone: normalizeStringField(record.phone)
    };
  }

  function loadDirectoryRecords(directory) {
    var dataUrl = directory.getAttribute('data-directory-json-url');

    if (!dataUrl || !window.fetch) {
      return Promise.reject(new Error('Directory data URL or fetch support is missing'));
    }

    return fetch(dataUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Directory JSON request failed with status ' + response.status);
        }

        return response.json();
      })
      .then(function (records) {
        if (!Array.isArray(records)) {
          throw new Error('Directory JSON must be an array');
        }

        return records.map(normalizeDirectoryRecord);
      });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function firstGroupCharacter(name) {
    var firstCharacter = String(name || '').trim().charAt(0).toUpperCase();
    return /^[A-Z]$/.test(firstCharacter) ? firstCharacter : '#';
  }

  function groupId(group) {
    return group === '#' ? 'number' : group.toLowerCase();
  }

  function normalizeName(name) {
    return String(name || '').trim().toLowerCase();
  }

  function websiteUrl(website) {
    if (!website) return '';
    return /^https?:\/\//i.test(website) ? website : 'https://' + website;
  }

  function instagramUrl(instagram) {
    if (!instagram) return '';
    var handle = instagram.replace(/^@/, '');
    return 'https://instagram.com/' + encodeURIComponent(handle);
  }

  function phoneUrl(phone) {
    if (!phone) return '';
    var number = phone.replace(/[^\d+]/g, '');
    return number ? 'tel:' + number : '';
  }

  function contactLink(type, href, label, newTab) {
    if (!href || !label) return '';
    var targetAttributes = newTab ? ' target="_blank" rel="noopener noreferrer"' : '';

    return [
      '<li>',
        '<a href="' + escapeHtml(href) + '"' + targetAttributes + '>',
          '<span class="flair-directory__contact-icon" aria-hidden="true">' + icons[type] + '</span>',
          '<span>' + escapeHtml(label) + '</span>',
          '<span class="flair-directory__contact-arrow" aria-hidden="true">' + icons.chevron + '</span>',
        '</a>',
      '</li>'
    ].join('');
  }

  function renderUnavailable(resultsElement) {
    resultsElement.innerHTML = [
      '<div class="flair-directory__empty" role="status">',
        '<h2>Directory unavailable.</h2>',
        '<p>The directory could not be loaded. Please refresh the page or try again later.</p>',
      '</div>'
    ].join('');
  }

  function renderRows(records, resultsElement) {
    if (!records.length) {
      resultsElement.innerHTML = [
        '<div class="flair-directory__empty" role="status">',
          '<h2>No exhibitors found.</h2>',
          '<p>Try searching by brand, showroom, category, or booth number.</p>',
        '</div>'
      ].join('');
      return;
    }

    var sortedRecords = records.slice().sort(function (a, b) {
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });

    var groupedRecords = sortedRecords.reduce(function (groups, record) {
      var group = firstGroupCharacter(record.name);
      groups[group] = groups[group] || [];
      groups[group].push(record);
      return groups;
    }, {});

    var groupOrder = Object.keys(groupedRecords).sort(function (a, b) {
      if (a === '#') return -1;
      if (b === '#') return 1;
      return a.localeCompare(b);
    });

    resultsElement.innerHTML = groupOrder.map(function (group) {
      var rows = groupedRecords[group].map(function (record) {
        var booth = record.booth ? '<span class="flair-directory__booth">Booth ' + escapeHtml(record.booth) + '</span>' : '';

        return [
          '<li>',
            '<button class="flair-directory__row" type="button" data-directory-record-id="' + escapeHtml(record.id) + '">',
              '<span class="flair-directory__name">' + escapeHtml(record.name) + '</span>',
              booth,
              '<span class="flair-directory__chevron" aria-hidden="true">' + icons.chevron + '</span>',
            '</button>',
          '</li>'
        ].join('');
      }).join('');

      return [
        '<div class="flair-directory__group" id="flair-directory-' + groupId(group) + '">',
          '<h2 class="flair-directory__group-title">' + escapeHtml(group) + '</h2>',
          '<ul class="flair-directory__list" role="list">' + rows + '</ul>',
        '</div>'
      ].join('');
    }).join('');
  }

  function normalizeFilter(value) {
    return String(value || '').trim().toLowerCase();
  }

  function recordSearchValues(record) {
    return [
      record.name,
      record.booth,
      record.booth ? 'Booth ' + record.booth : '',
      record.represented_by,
      record.website,
      record.instagram,
      record.email
    ].concat(record.categories || [], record.brands_represented || []);
  }

  function matchesSelectedFilters(record, selectedFilters) {
    if (!selectedFilters.length) return true;

    return selectedFilters.some(function (filter) {
      if (filter === 'showrooms') {
        return record.record_type === 'showroom';
      }

      return (record.categories || []).some(function (category) {
        return normalizeFilter(category) === filter;
      });
    });
  }

  function applyDirectoryFilters(records, selectedFilters, searchTerm) {
    var normalizedSearch = normalizeFilter(searchTerm);

    return records.filter(function (record) {
      var matchesSearch = true;

      if (normalizedSearch) {
        matchesSearch = recordSearchValues(record).some(function (value) {
          return normalizeFilter(value).indexOf(normalizedSearch) !== -1;
        });
      }

      return matchesSearch && matchesSelectedFilters(record, selectedFilters);
    });
  }

  function syncFilterButtons(directory, selectedFilters) {
    var clearButton = directory.querySelector('[data-filter-clear]');
    var filterButtons = directory.querySelectorAll('[data-filter-value]');
    var moreFiltersToggle = directory.querySelector('[data-more-filters-toggle]');
    var mobileFiltersToggle = directory.querySelector('[data-mobile-filters-toggle]');
    var hasActiveMoreFilter = false;

    if (clearButton) {
      clearButton.classList.toggle('is-active', selectedFilters.length === 0);
      clearButton.setAttribute('aria-pressed', selectedFilters.length === 0 ? 'true' : 'false');
    }

    filterButtons.forEach(function (button) {
      var filter = normalizeFilter(button.getAttribute('data-filter-value'));
      var isSelected = selectedFilters.indexOf(filter) !== -1;
      if (isSelected && button.closest('[data-more-filters-panel]')) {
        hasActiveMoreFilter = true;
      }
      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (moreFiltersToggle) {
      moreFiltersToggle.classList.toggle('has-active-more', hasActiveMoreFilter);
    }

    if (mobileFiltersToggle) {
      mobileFiltersToggle.classList.toggle('has-active-filters', selectedFilters.length > 0);
    }
  }

  function renderFilteredRows(records, resultsElement, selectedFilters, searchTerm) {
    renderRows(applyDirectoryFilters(records, selectedFilters, searchTerm), resultsElement);
  }

  function suggestionKey(value) {
    return normalizeFilter(value);
  }

  function directorySuggestions(records, searchTerm) {
    var normalizedSearch = normalizeFilter(searchTerm);
    var seen = {};
    var suggestions = [];

    if (normalizedSearch.length < 2) return suggestions;

    records.forEach(function (record) {
      [
        { value: record.name, label: record.name, type: 'Name' },
        { value: record.booth, label: record.booth ? 'Booth ' + record.booth : '', type: 'Booth' },
        { value: record.represented_by, label: record.represented_by, type: 'Represented by' }
      ].concat(
        (record.categories || []).map(function (category) {
          return { value: category, label: category, type: 'Category' };
        }),
        (record.brands_represented || []).map(function (brand) {
          return { value: brand, label: brand, type: 'Brand' };
        })
      ).forEach(function (suggestion) {
        var key = suggestionKey(suggestion.value);

        if (!suggestion.value || seen[key] || normalizeFilter(suggestion.label).indexOf(normalizedSearch) === -1) return;

        seen[key] = true;
        suggestions.push(suggestion);
      });
    });

    return suggestions.slice(0, 5);
  }

  function highlightedSuggestionLabel(label, searchTerm) {
    var normalizedSearch = normalizeFilter(searchTerm);
    var normalizedLabel = normalizeFilter(label);
    var matchIndex = normalizedLabel.indexOf(normalizedSearch);

    if (matchIndex === -1 || !normalizedSearch) return escapeHtml(label);

    return [
      escapeHtml(label.slice(0, matchIndex)),
      '<mark>',
      escapeHtml(label.slice(matchIndex, matchIndex + normalizedSearch.length)),
      '</mark>',
      escapeHtml(label.slice(matchIndex + normalizedSearch.length))
    ].join('');
  }

  function renderCategoryTags(categories) {
    if (!categories || !categories.length) return '';
    return categories.map(function (category) {
      return '<span class="flair-directory__tag">' + escapeHtml(category) + '</span>';
    }).join('');
  }

  function representedBrandsForShowroom(showroom, records) {
    if (showroom.record_type !== 'showroom') return [];

    return records.filter(function (record) {
      return record.record_type === 'represented_brand' && normalizeName(record.represented_by) === normalizeName(showroom.name);
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });
  }

  function renderBrandsRepresented(record, records) {
    var representedBrands = representedBrandsForShowroom(record, records);

    if (!representedBrands.length) return '';

    var brands = representedBrands.map(function (brand) {
      return [
        '<li>',
          '<button class="flair-directory__brand-pill" type="button" data-directory-brand-id="' + escapeHtml(brand.id) + '">',
            escapeHtml(brand.name),
          '</button>',
        '</li>'
      ].join('');
    }).join('');

    return [
      '<div class="flair-directory__drawer-section">',
        '<h3>Brands Represented</h3>',
        '<ul class="flair-directory__brands-list" role="list">' + brands + '</ul>',
      '</div>'
    ].join('');
  }

  function renderDrawerRelationship(record, records) {
    if (record.record_type === 'showroom') {
      return '<span class="flair-directory__meta-pill">Showroom</span>';
    }

    if (record.record_type !== 'represented_brand' || !record.represented_by) return '';

    var showroom = records.find(function (item) {
      return item.record_type === 'showroom' && normalizeName(item.name) === normalizeName(record.represented_by);
    });
    var showroomId = showroom ? ' data-directory-showroom-id="' + escapeHtml(showroom.id) + '"' : '';

    return [
      '<div class="flair-directory__drawer-relationship">',
        '<span class="flair-directory__meta-pill">Represented by</span>',
        '<button class="flair-directory__relationship-link" type="button"' + showroomId + '>' + escapeHtml(record.represented_by) + '</button>',
      '</div>'
    ].join('');
  }

  function renderContacts(record) {
    var links = [
      contactLink('website', websiteUrl(record.website), record.website, true),
      contactLink('instagram', instagramUrl(record.instagram), record.instagram, true),
      contactLink('email', record.email ? 'mailto:' + record.email : '', record.email, false),
      contactLink('phone', phoneUrl(record.phone), record.phone, false)
    ].filter(Boolean).join('');

    if (!links) return '';

    return '<ul class="flair-directory__contact-list" role="list">' + links + '</ul>';
  }

  function renderDrawer(record, records, drawerContent) {
    var booth = record.booth ? '<p class="flair-directory__drawer-booth">Booth ' + escapeHtml(record.booth) + '</p>' : '';

    drawerContent.innerHTML = [
      '<div class="flair-directory__drawer-header">',
        '<h2 class="flair-directory__drawer-title">' + escapeHtml(record.name) + '</h2>',
        booth,
        renderDrawerRelationship(record, records),
      '</div>',
      '<div class="flair-directory__drawer-section">',
        '<h3>Categories</h3>',
        '<div class="flair-directory__tag-list">' + renderCategoryTags(record.categories) + '</div>',
      '</div>',
      renderBrandsRepresented(record, records),
      renderContacts(record)
    ].join('');
  }

  function shouldLockScroll() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function syncSearchPlaceholder(searchForm) {
    var searchInput = searchForm.querySelector('input[type="search"]');
    if (!searchInput) return;

    var desktopPlaceholder = searchInput.getAttribute('placeholder') || '';
    var mobilePlaceholder = 'Search brands, showrooms, booths';
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function updatePlaceholder() {
      searchInput.setAttribute('placeholder', mobileQuery.matches ? mobilePlaceholder : desktopPlaceholder);
    }

    updatePlaceholder();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updatePlaceholder);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(updatePlaceholder);
    }
  }

  function lockPageScroll() {
    if (!shouldLockScroll() || document.body.classList.contains('flair-directory-drawer-active')) return;

    var scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.flairDirectoryScrollY = String(scrollY);
    document.body.classList.add('flair-directory-drawer-active');
    document.body.style.top = '-' + scrollY + 'px';
  }

  function unlockPageScroll() {
    if (!document.body.classList.contains('flair-directory-drawer-active')) return;

    var scrollY = parseInt(document.body.dataset.flairDirectoryScrollY || '0', 10);
    document.body.classList.remove('flair-directory-drawer-active');
    document.body.style.top = '';
    delete document.body.dataset.flairDirectoryScrollY;
    window.scrollTo(0, scrollY);
  }

  function openDrawer(directory, drawer, record, records, drawerContent) {
    renderDrawer(record, records, drawerContent);
    directory.classList.remove('flair-directory--drawer-closed');
    directory.classList.add('flair-directory--drawer-open', 'is-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockPageScroll();

    directory.querySelectorAll('[data-directory-record-id]').forEach(function (row) {
      row.classList.toggle('is-active', row.getAttribute('data-directory-record-id') === record.id);
    });
  }

  function closeDrawer(directory, drawer) {
    directory.classList.remove('flair-directory--drawer-open', 'is-drawer-open');
    directory.classList.add('flair-directory--drawer-closed');
    drawer.setAttribute('aria-hidden', 'true');
    unlockPageScroll();

    directory.querySelectorAll('[data-directory-record-id]').forEach(function (row) {
      row.classList.remove('is-active');
    });
  }

  document.querySelectorAll('[data-flair-directory]').forEach(function (directory) {
    var resultsElement = directory.querySelector('[data-directory-results]');
    var drawer = directory.querySelector('.flair-directory__drawer');
    var drawerContent = directory.querySelector('[data-directory-drawer-content]');
    var closeButton = directory.querySelector('.flair-directory__close');
    var searchForm = directory.querySelector('.flair-directory__search');
    var filters = directory.querySelector('[data-directory-filters]');
    var moreFiltersToggle = directory.querySelector('[data-more-filters-toggle]');
    var moreFiltersPanel = directory.querySelector('[data-more-filters-panel]');
    var mobileControls = directory.querySelector('[data-mobile-controls]');
    var mobileFiltersToggle = directory.querySelector('[data-mobile-filters-toggle]');
    var mobileFiltersPanel = directory.querySelector('[data-mobile-filters-panel]');
    var mobileAlphaToggle = directory.querySelector('[data-mobile-alpha-toggle]');
    var mobileAlphaPanel = directory.querySelector('[data-mobile-alpha-panel]');
    var selectedFilters = [];
    var searchTerm = '';

    if (!resultsElement || !drawer || !drawerContent) return;

    syncFilterButtons(directory, selectedFilters);

    loadDirectoryRecords(directory)
      .then(function (records) {
        directoryRecords = records;
        renderFilteredRows(directoryRecords, resultsElement, selectedFilters, searchTerm);
      })
      .catch(function (error) {
        console.error('FLAIR directory data failed to load.', error);
        renderUnavailable(resultsElement);
      });

    function closeMobilePanels() {
      if (mobileFiltersToggle && mobileFiltersPanel) {
        mobileFiltersToggle.setAttribute('aria-expanded', 'false');
        mobileFiltersPanel.hidden = true;
      }

      if (mobileAlphaToggle && mobileAlphaPanel) {
        mobileAlphaToggle.setAttribute('aria-expanded', 'false');
        mobileAlphaPanel.hidden = true;
      }
    }

    function handleFilterClick(event) {
      var clearButton = event.target.closest('[data-filter-clear]');
      var filterButton = event.target.closest('[data-filter-value]');

      if (clearButton) {
        selectedFilters = [];
      } else if (filterButton) {
        var filter = normalizeFilter(filterButton.getAttribute('data-filter-value'));
        var filterIndex = selectedFilters.indexOf(filter);

        if (filterIndex === -1) {
          selectedFilters.push(filter);
        } else {
          selectedFilters.splice(filterIndex, 1);
        }
      } else {
        return;
      }

      syncFilterButtons(directory, selectedFilters);
      renderFilteredRows(directoryRecords, resultsElement, selectedFilters, searchTerm);
    }

    if (searchForm) {
      var searchInput = searchForm.querySelector('input[type="search"]');
      var suggestionsElement = document.createElement('div');

      suggestionsElement.className = 'flair-directory__suggestions';
      suggestionsElement.hidden = true;
      suggestionsElement.setAttribute('data-directory-suggestions', '');
      searchForm.appendChild(suggestionsElement);

      syncSearchPlaceholder(searchForm);

      function closeSuggestions() {
        suggestionsElement.hidden = true;
        suggestionsElement.innerHTML = '';
      }

      function renderSuggestions() {
        var suggestions = directorySuggestions(directoryRecords, searchInput.value);

        if (!suggestions.length) {
          closeSuggestions();
          return;
        }

        suggestionsElement.innerHTML = suggestions.map(function (suggestion) {
          return [
            '<button class="flair-directory__suggestion" type="button" data-suggestion-value="' + escapeHtml(suggestion.value) + '">',
              '<span class="flair-directory__suggestion-label">' + highlightedSuggestionLabel(suggestion.label, searchInput.value) + '</span>',
              '<span class="flair-directory__suggestion-type">' + escapeHtml(suggestion.type) + '</span>',
            '</button>'
          ].join('');
        }).join('');
        suggestionsElement.hidden = false;
      }

      function applySearch(value) {
        searchInput.value = value;
        searchTerm = value.trim();
        renderFilteredRows(directoryRecords, resultsElement, selectedFilters, searchTerm);
      }

      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
      });

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          searchTerm = searchInput.value.trim();
          renderFilteredRows(directoryRecords, resultsElement, selectedFilters, searchTerm);
          renderSuggestions();
        });

        searchInput.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            closeSuggestions();
          }
        });
      }

      suggestionsElement.addEventListener('click', function (event) {
        var suggestionButton = event.target.closest('[data-suggestion-value]');
        if (!suggestionButton) return;

        applySearch(suggestionButton.getAttribute('data-suggestion-value') || '');
        closeSuggestions();
        searchInput.focus();
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('.flair-directory__search')) return;
        closeSuggestions();
      });
    }

    if (filters) {
      filters.addEventListener('click', handleFilterClick);
    }

    if (mobileFiltersPanel) {
      mobileFiltersPanel.addEventListener('click', handleFilterClick);
    }

    if (moreFiltersToggle && moreFiltersPanel) {
      moreFiltersToggle.addEventListener('click', function () {
        var isOpen = moreFiltersToggle.getAttribute('aria-expanded') === 'true';
        moreFiltersToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        moreFiltersPanel.hidden = isOpen;
        if (filters) {
          filters.classList.toggle('is-more-open', !isOpen);
        }
      });

      document.addEventListener('click', function (event) {
        if (moreFiltersPanel.hidden || event.target.closest('[data-directory-filters]')) return;
        moreFiltersToggle.setAttribute('aria-expanded', 'false');
        moreFiltersPanel.hidden = true;
        if (filters) {
          filters.classList.remove('is-more-open');
        }
      });
    }

    if (mobileFiltersToggle && mobileFiltersPanel) {
      mobileFiltersToggle.addEventListener('click', function () {
        var isOpen = mobileFiltersToggle.getAttribute('aria-expanded') === 'true';
        closeMobilePanels();
        mobileFiltersToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        mobileFiltersPanel.hidden = isOpen;
      });
    }

    if (mobileAlphaToggle && mobileAlphaPanel) {
      mobileAlphaToggle.addEventListener('click', function () {
        var isOpen = mobileAlphaToggle.getAttribute('aria-expanded') === 'true';
        closeMobilePanels();
        mobileAlphaToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        mobileAlphaPanel.hidden = isOpen;
      });

      mobileAlphaPanel.addEventListener('click', function (event) {
        if (event.target.closest('a')) {
          closeMobilePanels();
        }
      });
    }

    if (mobileControls) {
      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-mobile-controls]')) return;
        closeMobilePanels();
      });
    }

    resultsElement.addEventListener('click', function (event) {
      var row = event.target.closest('[data-directory-record-id]');
      if (!row) return;

      var record = directoryRecords.find(function (item) {
        return item.id === row.getAttribute('data-directory-record-id');
      });

      if (record) {
        openDrawer(directory, drawer, record, directoryRecords, drawerContent);
      }
    });

    drawer.addEventListener('click', function (event) {
      var brandButton = event.target.closest('[data-directory-brand-id]');
      var showroomButton = event.target.closest('[data-directory-showroom-id]');

      if (brandButton) {
        var brand = directoryRecords.find(function (item) {
          return item.id === brandButton.getAttribute('data-directory-brand-id');
        });

        if (brand) {
          openDrawer(directory, drawer, brand, directoryRecords, drawerContent);
        }
        return;
      }

      if (!showroomButton) return;

      var showroom = directoryRecords.find(function (item) {
        return item.id === showroomButton.getAttribute('data-directory-showroom-id');
      });

      if (showroom) {
        openDrawer(directory, drawer, showroom, directoryRecords, drawerContent);
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeDrawer(directory, drawer);
      });
    }

    window.addEventListener('resize', function () {
      if (!directory.classList.contains('flair-directory--drawer-open') || shouldLockScroll()) return;
      unlockPageScroll();
    });
  });
})();
